export default function setReducer(reducer){
    this.dataReducer = reducer
}